import { Box, Grid } from '@mui/material';
import { TenantForSharedUserType } from 'src/types/tenant';
import { themeColors } from 'src/theme';
import { useTranslation } from 'react-i18next';
import { H2, P2R } from '../Typography';
import { AcceptButton, ButtonContainer, StyledDisabledInput } from './styled';

type PropsType = {
  tenant: TenantForSharedUserType;
  onAcceptHandler: (id: number) => void;
};

function AboutContactCompany({ tenant, onAcceptHandler }: PropsType) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 4, maxWidth: '622px', borderRadius: '4px', border: `1px solid ${themeColors.grayMedium}` }}>
      <Box sx={{ backgroundColor: themeColors.grayLight, px: 3, py: 4 }}>
        <Box sx={{ my: 2 }}>
          <H2>{t('aboutContractorPage.title')}</H2>
        </Box>

        <Grid container>
          <Grid sx={{ py: 0 }} item xs={12}>
            <StyledDisabledInput
              sx={{ py: 0 }}
              label={t('aboutContractorPage.companyName')}
              value={tenant.title || t('aboutContractorPage.noData')}
              disabled
            />
          </Grid>

          <Grid sx={{ py: 0 }} item xs={12}>
            <StyledDisabledInput
              sx={{ py: 0 }}
              label={t('aboutContractorPage.phone')}
              value={tenant.phone}
              placeholder={t('aboutContractorPage.noData')}
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <StyledDisabledInput
              sx={{ py: 0 }}
              label={t('aboutContractorPage.website')}
              value={tenant.website}
              placeholder={t('aboutContractorPage.noData')}
              disabled
            />
          </Grid>

          <Grid item xs={12} sx={{ mb: 1 }}>
            <P2R sx={{ fontWeight: 600 }}>{t('aboutContractorPage.pointOfContact')} </P2R>
          </Grid>

          <Grid item xs={12}>
            <StyledDisabledInput
              label={t('aboutContractorPage.fullName')}
              value={tenant.pointOfContact?.name}
              placeholder={t('aboutContractorPage.noData')}
              disabled
            />
          </Grid>

          <Grid item xs={12}>
            <StyledDisabledInput
              label={t('aboutContractorPage.phone')}
              value={tenant.pointOfContact?.number}
              placeholder={t('aboutContractorPage.noData')}
              disabled
            />
          </Grid>
        </Grid>
      </Box>

      {!tenant.isAccepted && (
        <ButtonContainer>
          <AcceptButton onClick={() => onAcceptHandler(tenant.id)} primary={false}>
            {t('aboutContractorPage.accept')}
          </AcceptButton>
        </ButtonContainer>
      )}
    </Box>
  );
}

export default AboutContactCompany;
